import React from "react";
import "../../index.css";
import { Link } from "react-router";
import { Tooltip } from "react-tooltip";
import zion3 from '../../Assets/Img/zion3.jpg'

const Chap8 = () => {
  return (
    <div className="chapter-container">

      <div className="chapterFooter">
        <Link to="/Chap7">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap9">Next</Link>
      </div>

      <h1 className="chapterHeading">Chapter 8: Zion Will Be Sanctified</h1>

      <img src={zion3} className='image' alt='Angels approaching the New Jerusalem' />

      <div className="wrapper">

      <div className="paragraph">
        <p>
          However, this opposition will work to Zion’s advantage. The opposition
          will purify the Zion builders through a refining fire, instilling
          great spiritual power. Nephi beheld that, as the world fights against
          Zion, the inhabitants will be endowed “with the power of God in great
          glory.” 
          <btn id="clickable1" className="footnote">1 </btn>
          <Tooltip anchorSelect="#clickable1" className="footnote-size" clickable>1 Nephi 14:13.</Tooltip>
          
          With this power and glory, “the sons and daughters of the
          faithful will prophesy and see visions and the old men dream dreams,”
          as Moroni quoted the words of the Old Testament prophet Joel to Joseph
          Smith.
        </p>
      </div>

      <div className="paragraph">
        <p>
          As the Mormons and Lamanites build Zion, the people will increase in
          righteousness and become truly Christlike. They will be filled with
          tangible glory so that they personally, and the city they are
          building, will shine forth as a beacon to the world. Mormon apostle
          Orson Pratt stated, “… her dwellings shall be encircled with glory;
          her light shall be as the sun, and her beauty as the morning; her
          tabernacles shall be as the dwelling places, kings shall arise and
          worship.”
          <btn id="clickable2" className="footnote">2 </btn>
          <Tooltip anchorSelect="#clickable2" className="footnote-size" clickable>“Divine Authenticity Of The Book Of Mormon: Prophetic Evidence In Favor Of The Book Of Mormon,” in A Series Of Pamphlets By Orson Pratt (Liverpool, England, 1851), p. 91.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Book of Mormon gives an example of this. During Christ’s
          appearance to the Nephites, he promised that the people would be
          baptized “with fire and with the Holy Ghost.” “And as they looked to
          behold, they cast their eyes toward heaven, and they saw the heavens
          open, and they saw angels descending out of heaven as it were in the
          midst of fire, and they came down and encircled those little ones
          about, and they were encircled about with fire; and the angels did
          minister unto them.”
          <btn id="clickable3" className="footnote">3 </btn>
          <Tooltip anchorSelect="#clickable3" className="footnote-size" clickable>3 Nephi 17:24.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The next day Christ appeared and bestowed further divine endowments.
          “And behold, they were encircled about as if it were by fire; and it
          came down from heaven.” 
          <btn id="clickable4" className="footnote">4 </btn>
          <Tooltip anchorSelect="#clickable4" className="footnote-size" clickable>3 Nephi 19:14.</Tooltip>
          
          Christ prayed to the Father on their behalf.
          “And his countenance did smile upon them, and the light of his
          countenance did shine upon them, and behold they were as white as the
          countenance and also the garments of Jesus; and behold the whiteness
          thereof did exceed all the whiteness, yea, even there could be nothing
          upon earth so white as the whiteness thereof.”
        <btn id="clickable5" className="footnote">5 </btn>
        <Tooltip anchorSelect="#clickable5" className="footnote-size" clickable>3 Nephi 19:25.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          To an even greater degree, Zion will be endowed with glory. A fire and
          flame of glory will consume the dross and purify all physical
          elements. The people, buildings, and streets will shine and burn with
          holy flame. Third Mormon prophet John Taylor declared, “In the name of
          Israel’s God,” Zion will be built and that “the glory of God” will
          “rest upon it, upon every dwelling in Mount Zion.” 
          <btn id="clickable6" className="footnote">6 </btn>
          <Tooltip anchorSelect="#clickable6" className="footnote-size" clickable>John Taylor, Journal of Discourses, March 21, 1880, vol. 21, p. 253.</Tooltip>
          
          Fourth Mormon
          prophet Wilford Woodruff met with the Quorum of the Twelve “and
          conversed upon ... the light, blessings and glory that awaiteth Zion.”
          <btn id="clickable7" className="footnote">7 </btn>
          <Tooltip anchorSelect="#clickable7" className="footnote-size" clickable>Journal of Wilford Woodruff, December 2, 1843.</Tooltip>


          The glory around and about will fill the people’s minds, opening the
          visions of eternity – past, present, and future. It will be like a
          fountain of living water. The people will move about in paradisiacal
          glory, a tangible element of warmth and love.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Of this glory in Zion, Mormon apostle Orson Pratt stated, “That true
          light that emanates from the great fountain of light, the Messiah, ...
          will be rendered visible to the eyes of all the inhabitants of that
          city. And shall I limit it there? No. The Light will shine so
          conspicuously from that city, extending to the very heavens, that it
          will in reality be like unto a city set upon a hill that cannot be
          hid, and it will have quite a tendency to strike terror to all the
          nations of the earth.”
          <btn id="clickable8" className="footnote">8 </btn>
          <Tooltip anchorSelect="#clickable8" className="footnote-size" clickable>Orson Pratt, Journal of Discourses, October 26, 1879, vol. 24, p. 29.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Zion is the power and glory that Enoch and his people achieved. “And
          Enoch and all his people walked with God, and he dwelt in the midst of
          Zion; and it came to pass that Zion was not, for God received it up
          into his own bosom; and from thence went forth the saying, Zion is
          Fled.” 
          <btn id="clickable9" className="footnote">9 </btn>
          <Tooltip anchorSelect="#clickable9" className="footnote-size" clickable>Moses 7:69.</Tooltip>
          
          Enoch’s Zion was too pure and holy to remain on the earth. But,
          according to Joseph, the city will return. Zion is the power and glory
          God attempted to give Israel through Moses at Mount Sinai, but the
          Israelites rejected it. Isaiah stated, “Awake, awake; put on thy
          strength, O Zion,” which means Joseph Smith explained, “to return to
          that power which she had lost.”
          <btn id="clickable10" className="footnote">10 </btn>
          <Tooltip anchorSelect="#clickable10" className="footnote-size" clickable>D&C 113:8.</Tooltip>
        </p>
      </div>

      <h2 className="headlinePadding">Zion Will Be Terrible to the Wicked and Refuge for the Righteous</h2>

      <div className="paragraph">
        <p>
          The inhabitants of Zion will also be made terrible, for the glory of
          the Lord will be upon Zion. Joseph revealed, “The day shall come when
          the nations of the earth shall tremble because of her and shall fear
          because of her terrible ones.” 
          <btn id="clickable11" className="footnote">11 </btn>
          <Tooltip anchorSelect="#clickable11" className="footnote-size" clickable>D&C 64:43.</Tooltip>
          
          As Zion increases in righteousness, the
          holy city will become more and more spiritualized to the point it is
          worthy to receive visitations from Christ – prior to his appearance to
          the world at his Second Coming. At that point, Christ’s glory will
          rest upon Zion, raising it to an even greater sanctified level. Upon
          every dwelling place of Mount Zion, the Lord will create a cloud and
          smoke by day and the shining of a flaming fire by night; for upon all,
          the glory of Zion shall be a defence.
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph revealed, “She shall prosper, and spread herself and become
          very glorious, very great, and very terrible. And the nations of the
          earth shall honor her and shall say: Surely Zion is the city of our
          God, and surely Zion cannot fall, neither be moved out of her place,
          for God is there.”
          <btn id="clickable12" className="footnote">12 </btn>
          <Tooltip anchorSelect="#clickable12" className="footnote-size" clickable>D&C 97:18.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          But in proportion as Zion prospers, increasingly gross wickedness will
          cover the earth. God’s spirit will withdraw from humankind. Spiritual
          darkness will cloud people’s minds. Murder, exploitation, whoredoms,
          and fornications will run rampant. People will be as in Noah’s day
          before the flood – to which God responded, “And God saw that the
          wickedness of man was great in the earth, and that every imagination
          of the thoughts of his heart was only evil continually. And it
          repented the Lord that he had made man on the earth.”
          <btn id="clickable13" className="footnote">13 </btn>
          <Tooltip anchorSelect="#clickable13" className="footnote-size" clickable>Genesis 6:5-7.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          The Book of Mormon gives a glimpse of the wickedness that Joseph
          prophesied would cover the earth before the Second Coming. Prior to
          the end of Nephite civilization, the people were “without principle
          and past feeling.” Mormon wrote, “A continual scene of wickedness and
          abominations has been before mine eyes.” 
          <btn id="clickable14" className="footnote">14 </btn>
          <Tooltip anchorSelect="#clickable14" className="footnote-size" clickable>Mormon 2:18.</Tooltip>
          
          Mormon wrote of the Nephites,
          “Many of the daughters of the Lamanites have they taken prisoner, and
          after depriving them of … chastity and virtue ... they did murder them
          in a most cruel manner … devour[ing] their flesh like unto wild
          beasts.”
          <btn id="clickable15" className="footnote">15 </btn>
          <Tooltip anchorSelect="#clickable15" className="footnote-size" clickable>Moroni 9:9-10.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          According to Joseph Smith, he was shown in vision the violence and
          destruction on the near horizon. First Presidency Counselor Jedediah
          Grant stated, “Three days before the Prophet Joseph started for
          Carthage ... he told several of us of the night the visions of heaven
          were open to him, in which he saw the American continent drenched in
          blood, and he saw nation rising up against nation. He saw the father
          shed the blood of the son, and the son the blood of the father; the
          mother put to death the daughter, and the daughter the mother; and
          natural affection forsook the hearts of the wicked.”
          <btn id="clickable16" className="footnote">16 </btn>
          <Tooltip anchorSelect="#clickable16" className="footnote-size" clickable>Jedediah M. Grant, Improvement Era, Vol. XVIII., Feb 1915, No. 4.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Jedediah continued, Joseph stated, “I saw men hunting the lives of
          their own sons, and brother murdering brother, women killing their own
          daughters, and daughters seeking the lives of their mothers. I saw
          armies arrayed against armies. I saw blood, desolation, fires. The Son
          of Man has said that the mother shall be against the daughter, and the
          daughter against the mother.”
          <btn id="clickable17" className="footnote">17 </btn>
          <Tooltip anchorSelect="#clickable17" className="footnote-size" clickable>History of the Church, vol. 3, p. 391.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Brigham Young stated, “that state will be against state, city against
          city, neighborhood against neighborhood ... Christian against
          Christian, and man against man.” 
          <btn id="clickable18" className="footnote">18 </btn>
          <Tooltip anchorSelect="#clickable18" className="footnote-size" clickable>Brigham Young, Deseret News Weekly, XI (May 1, 1861), p. 66.</Tooltip>
          
          Third Mormon prophet John Taylor
          stated, “There is yet to come a sound of war, trouble and distress, in
          which brother will be arrayed against brother, father against son, son
          against father, a scene of desolation and destruction that will
          permeate our land until it will be a vexation to hear the report
          thereof.”
          <btn id="clickable19" className="footnote">19 </btn>
          <Tooltip anchorSelect="#clickable19" className="footnote-size" clickable>John Taylor, Journal of Discourses, October 6, 1879, vol. 20, p. 318. See also Journal of Discourses, April 13, 1862, vol. 9, p. 342.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          Joseph revealed that, in that day, every man who will not “take his
          sword against his neighbor” will have to “flee unto Zion for safety.”
          <btn id="clickable20" className="footnote">20 </btn>
          <Tooltip anchorSelect="#clickable20" className="footnote-size" clickable>D&C 45:68.</Tooltip>


          John Bernhisel reported that Joseph stated, “The nations are even now
          arming for the conflict which they foresee must necessarily ensue. In
          the cruel desolation of war, men will be slain by hundreds, thousands,
          and perhaps millions. Their widows and orphans will be compelled to
          flee to Zion for safety, and it will become the bounden duty of the
          Elders of Israel to provide for their sustenance and welfare.”
          <btn id="clickable21" className="footnote">21 </btn>
          <Tooltip anchorSelect="#clickable21" className="footnote-size" clickable>Washington Franklin Anderson, “Reminiscences of John M. Bernhisel,” typewritten manuscript, Church Historian’s Library, p. 1-4.</Tooltip>
        </p>
      </div>

      <div className="paragraph">
        <p>
          When the world reaches this level of debauchery, Christ’s cup of wrath
          will overflow. His arm will be made bare. Joseph revealed, “Mine
          indignation is soon to be poured out without measure upon all nations;
          and this will I do when the cup of their iniquity is full.” 
          <btn id="clickable22" className="footnote">22 </btn>
          <Tooltip anchorSelect="#clickable22" className="footnote-size" clickable>D&C 101:11.</Tooltip>
          
          During
          this awful situation, the wicked will increasingly persecute the
          upright people of the earth. These good souls who refuse to give into
          wickedness will look for deliverance. They will hear of a shining city
          in the center of America. The righteous of the world will flee to Zion
          for refuge.
        </p>
      </div>
      </div>

      <div className="chapterFooter">
        <Link to="/Chap7">Previous</Link>
        <Link to="/">Home</Link>
        <Link to="/Chap9">Next</Link>
      </div>
      
    </div>
  );
};

export default Chap8;
